import { useState, useCallback } from "react";

// Simplified custom hook for managing API state
export const useApiState = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleError = useCallback((error, context) => {
    console.error(`${context}:`, error);
    const message =
      error.response?.data?.message ||
      error.message ||
      "An unexpected error occurred";
    setError(`${context}: ${message}`);
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  const executeAsync = useCallback(
    async (asyncFunction, context = "Operation") => {
      try {
        setLoading(true);
        setError(null);
        const result = await asyncFunction();
        return result;
      } catch (error) {
        handleError(error, context);
        // throw error; // Re-throw so caller can handle if needed
      } finally {
        setLoading(false);
      }
    },
    [handleError]
  );

  return {
    loading,
    error,
    clearError,
    executeAsync,
  };
};
